import React from 'react'
import { isEmpty } from '../utils/CDPUtils'
import { createSelectBoxYear, createSelectBoxDayOrMonth, calcLastDayOfMonth } from './helper/Calendar'

const years = (from, to) => {
    const now = new Date()
    const year = now.getFullYear()

    // 年オプションの範囲を個別で実装してください *from to を逆にするとソートも逆になる
    from = year - from
    to = year - to
    return createSelectBoxYear(from, to)
}

const finalEduBgTypes = [{ label: '大学院', value: '大学院' },
    { label: '大学', value: '大学' },
    { label: '専門学校', value: '専門学校' },
    { label: '短大', value: '短大' },
    { label: '高校', value: '高校' },
    { label: 'その他', value: 'その他' }]

const workExperienceTypes = [{ label: '建設・住宅', value: '建設・住宅' },
    { label: '不動産', value: '不動産' },
    { label: '水産・食品', value: '水産・食品' },
    { label: '繊維・アパレル', value: '繊維・アパレル' },
    { label: '化学・石油', value: '化学・石油' },
    { label: '医薬品・医療機器', value: '医薬品・医療機器' },
    { label: '化粧品', value: '化粧品' },
    { label: '紙・建材・資材', value: '紙・建材・資材' },
    { label: '鉄鋼・金属・機械', value: '鉄鋼・金属・機械' },
    { label: '電子・電機', value: '電子・電機' },
    { label: '自動車・ディーラー', value: '自動車・ディーラー' },
    { label: '倉庫・運輸', value: '倉庫・運輸' },
    { label: '文具・事務機・印刷', value: '文具・事務機・印刷' },
    { label: '情報処理・ソフトウェア', value: '情報処理・ソフトウェア' },
    { label: '通信', value: '通信' },
    { label: '電力・ガス', value: '電力・ガス' },
    { label: '商社・問屋', value: '商社・問屋' },
    { label: '銀行・信金・信組', value: '銀行・信金・信組' },
    { label: '信販・クレジット', value: '信販・クレジット' },
    { label: 'リース', value: 'リース' },
    { label: '生命保険', value: '生命保険' },
    { label: '損害保険', value: '損害保険' },
    { label: '証券', value: '証券' },
    { label: '商品・先物', value: '商品・先物' },
    { label: '流通・専門店', value: '流通・専門店' },
    { label: 'サービス・コンサルティング', value: 'サービス・コンサルティング' },
    { label: 'マスコミ・広告', value: 'マスコミ・広告' },
    { label: '教育・官公庁', value: '教育・官公庁' },
    { label: '旅行・レジャー', value: '旅行・レジャー' },
    { label: 'その他', value: 'その他' }]

const changeOccupationTypes = [{ label: '0回', value: '0回' },
    { label: '1回', value: '1回' },
    { label: '2回', value: '2回' },
    { label: '3回', value: '3回' },
    { label: '4回', value: '4回' },
    { label: '5回以上', value: '5回以上' }]

const nowOccupationTypes = [{ label: '在職中（アルバイトは除く）', value: '在職中（アルバイトは除く）' },
    { label: '離職中', value: '離職中' }]

const whereCDPMemoTypes1 = [{ label: '北海道', value: '北海道' },
    { label: '青森県', value: '青森県' },
    { label: '岩手県', value: '岩手県' },
    { label: '宮城県', value: '宮城県' },
    { label: '秋田県', value: '秋田県' },
    { label: '福島県', value: '福島県' },
    { label: '茨城県', value: '茨城県' },
    { label: '栃木県', value: '栃木県' },
    { label: '群馬県', value: '群馬県' },
    { label: '埼玉県', value: '埼玉県' },
    { label: '千葉県', value: '千葉県' },
    { label: '東京都', value: '東京都' },
    { label: '神奈川県', value: '神奈川県' },
    { label: '山梨県', value: '山梨県' },
    { label: '長野県', value: '長野県' },
    { label: '静岡県', value: '静岡県' },
    { label: '新潟県', value: '新潟県' },
    { label: '富山県', value: '富山県' },
    { label: '石川県', value: '石川県' },
    { label: '福井県', value: '福井県' },
    { label: '岐阜県', value: '岐阜県' },
    { label: '愛知県', value: '愛知県' },
    { label: '三重県', value: '三重県' },
    { label: '滋賀県', value: '滋賀県' },
    { label: '京都府', value: '京都府' },
    { label: '大阪府', value: '大阪府' },
    { label: '兵庫県', value: '兵庫県' },
    { label: '奈良県', value: '奈良県' },
    { label: '和歌山県', value: '和歌山県' },
    { label: '岡山県', value: '岡山県' },
    { label: '広島県', value: '広島県' },
    { label: '山口県', value: '山口県' },
    { label: '香川県', value: '香川県' },
    { label: '愛媛県', value: '愛媛県' },
    { label: '福岡県', value: '福岡県' },
    { label: '長崎県', value: '長崎県' },
    { label: '熊本県', value: '熊本県' },
    { label: '宮崎県', value: '宮崎県' },
    { label: '鹿児島県', value: '鹿児島県' }]

const whereCDPMemoTypes2 = [{ label: '北海道', value: '北海道' },
    { label: '青森県', value: '青森県' },
    { label: '岩手県', value: '岩手県' },
    { label: '宮城県', value: '宮城県' },
    { label: '秋田県', value: '秋田県' },
    { label: '福島県', value: '福島県' },
    { label: '茨城県', value: '茨城県' },
    { label: '栃木県', value: '栃木県' },
    { label: '群馬県', value: '群馬県' },
    { label: '埼玉県', value: '埼玉県' },
    { label: '千葉県', value: '千葉県' },
    { label: '東京都', value: '東京都' },
    { label: '神奈川県', value: '神奈川県' },
    { label: '山梨県', value: '山梨県' },
    { label: '長野県', value: '長野県' },
    { label: '静岡県', value: '静岡県' },
    { label: '新潟県', value: '新潟県' },
    { label: '富山県', value: '富山県' },
    { label: '石川県', value: '石川県' },
    { label: '福井県', value: '福井県' },
    { label: '岐阜県', value: '岐阜県' },
    { label: '愛知県', value: '愛知県' },
    { label: '三重県', value: '三重県' },
    { label: '滋賀県', value: '滋賀県' },
    { label: '京都府', value: '京都府' },
    { label: '大阪府', value: '大阪府' },
    { label: '兵庫県', value: '兵庫県' },
    { label: '奈良県', value: '奈良県' },
    { label: '和歌山県', value: '和歌山県' },
    { label: '岡山県', value: '岡山県' },
    { label: '広島県', value: '広島県' },
    { label: '山口県', value: '山口県' },
    { label: '香川県', value: '香川県' },
    { label: '愛媛県', value: '愛媛県' },
    { label: '福岡県', value: '福岡県' },
    { label: '長崎県', value: '長崎県' },
    { label: '熊本県', value: '熊本県' },
    { label: '宮崎県', value: '宮崎県' },
    { label: '鹿児島県', value: '鹿児島県' }]

function SelectField ({ dropDownName, fieldLabel, divStyleClass, styleClass, selectedValue, selectedMonth, selectedYear, attributeHandle, attributeBlur }) {
    let data = []

    if (dropDownName === 'dobyear') {
        const yearValue = years(13, 73)
        data = yearValue
    } else if (dropDownName === 'year') {
        data = years(0, 1)
    } else if (dropDownName === 'month' || dropDownName === 'dobmonth') {
        let lastMonth = 12
        if (!isEmpty(selectedYear)) {
            const now = new Date()
            const currentYear = now.getFullYear()
            const currentMonth = now.getMonth()
            lastMonth = (Number(selectedYear) === currentYear) ? currentMonth + 1 : 12
        }
        data = createSelectBoxDayOrMonth(lastMonth)
    } else if (dropDownName === 'day' || dropDownName === 'dobday') {
        let lastDay = 31
        if (!isEmpty(selectedYear) && !isEmpty(selectedMonth)) {
            lastDay = calcLastDayOfMonth(selectedYear, Number(selectedMonth))
        }
        data = createSelectBoxDayOrMonth(lastDay)
    } else if (dropDownName === 'finalEduBgTypes') {
        data = finalEduBgTypes
    } else if (dropDownName === 'workExperienceTypes') {
        data = workExperienceTypes
    } else if (dropDownName === 'changeOccupationTypes') {
        data = changeOccupationTypes
    } else if (dropDownName === 'nowOccupationTypes') {
        data = nowOccupationTypes
    } else if (dropDownName === 'whereCDPMemoTypes1') {
        data = whereCDPMemoTypes1
    } else if (dropDownName === 'whereCDPMemoTypes2') {
        data = whereCDPMemoTypes2
    }

    return (
        <div className={ divStyleClass }>
            <select className={ styleClass } name={ dropDownName } onChange={ attributeHandle }
                onBlur={ attributeBlur } id={ dropDownName } value={ selectedValue }>
                <option value="">--</option>
                { data.map(({ label, value }) => (
                    <option key={ value } value={ value } >
                        { label }
                    </option>
                ))
                }

            </select><a className='drop-arr'></a>
            {/* <p className='unit'>{ fieldLabel }</p> */}
        </div>
    )
}

export default SelectField
